import { useResponsive } from 'hooks/useResponsive'
import {
  MOBILE_SIZE_BREAKPOINT,
  MOBILE_TIMELINE_TRACK_HEIGHT,
  TIMELINE_TRACK_HEIGHT
} from 'consts'

export const useTrackHeight = () => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  return isMobile ? MOBILE_TIMELINE_TRACK_HEIGHT : TIMELINE_TRACK_HEIGHT
}
